module.exports = __webpack_public_path__ + "img/windsurfen--dark.598e69d4.svg";